<organization-select    #orgManager
                        autoSelectFirst = "true"
                        class           = "mr-3"
                        (change)        = "setOrg($event)"></organization-select>        
                                            
<site-select            #siteManager
                        [org]           =   "orgManager?.currentValue"
                        autoSelectFirst =   "true"
                        class           =   "mr-3"
                        (change)        =   "setSite($event)"></site-select>

<device-select          #deviceManager
                        [site]          =   "siteManager?.currentValue"
                        [type]          =   "20"
                        autoSelectFirst =   "true"
                        class           =   "mr-3"
                        select_name     =   "device.name.counter"
                        (change)        =   "setDevice($event)"></device-select>
<br>

<help-alert 
                            action      = "help.page.operator_assign.action" 
                            info        = "help.info"
                            description = "help.page.operator_assign.description"></help-alert>
<br>
<br>

<custom-table           #opeAssignTable
                        table_id            =   "opeAssignTable"
                        title_single        =   "tables.assign_operator.title_single"
                        title_multiple      =   "tables.assign_operator.title"
                        filter_title        =   "tables.assign_operator.filter_title"
                        search_title        =   "tables.assign_operator.search_title"
                        [columns]           =   "assignOperatorColumns"
                        [values]            =   "values"
                        [parent]            =   "this"
                        [create]            =   "false"
                        [update]            =   "false"
                        [delete]            =   "false"
                        [buttons]           =   "buttons"></custom-table>
<br>
